// extracted by mini-css-extract-plugin
module.exports = {"cpcmoqt":"cpcmoqt","c1bk5utz":"c1bk5utz"};